<template>
    <tr class="privacy-flag" :class="{'not-scrolled':!pargraph.scrolled && flag.mandatory}">
        <td class="privacy-flag-checkbox">
            <input v-if="flag.mandatory" style="margin: 0px 3px 3px 0px; " type="checkbox"
                v-model="flag.selected"
                required="required"
                :class="{'privacy-flag-chk-big': !greaterThan600, 'required': true}"
                :disabled="!pargraph.scrolled && flag.mandatory">

            <input  v-if="!flag.mandatory"
                    style="margin: 0px 3px 3px 0px; " type="checkbox"
                    v-model="flag.selected"
                    :class="{'privacy-flag-chk-big': !greaterThan600}"
                    :disabled="!pargraph.scrolled && flag.mandatory">
        </td>
        <td>
            <b><span v-html="showTextCheckbox"></span>
                <span v-if="flag.mandatory">*</span>
            </b>
        </td>
    </tr>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      greaterThan600: window.innerWidth > 600
    }
  },
  name: 'PrivacyFlag',
  props: ['flag', 'pargraph'],
  watch: {
    'flag.selected' () {
      let $el = document.getElementsByClassName(this.flag.code)

      if ($el.length > 0) {
        for (let i = 0; i < $el.length; i++) {
          $el[i].checked = this.flag.selected
        }

        // console.log(this.flag.code, $el.checked)
      }
    }
  },
  computed: {
    ...mapGetters(['allScrolled']),
    showTextCheckbox () {
      let $tagLink = this.$store.state.tagLink
      let $tagLinkLabel = this.$store.state.tagLinkLabel
      let $labelLink = this.$store.state.tradLinkLabel[this.$store.state.language]
      if ($labelLink === undefined) $labelLink = 'Leggi l\'informativa completa'
      let $text = this.flag.text
      let $posLink = $text.toLowerCase().indexOf($tagLink)
      if ($posLink > -1) {
        let $urlLink = $text.substr($posLink + $tagLink.length).trim()
        let $posLinkLabel = $text.toLowerCase().indexOf($tagLinkLabel)
        if ($posLinkLabel > -1) {
          $urlLink = $text.substring($posLink + $tagLink.length, $posLinkLabel).trim()
          let $newLabelLink = $text.substr($posLinkLabel + $tagLinkLabel.length).trim()
          if ($newLabelLink !== '') $labelLink = $newLabelLink
        }
        let $subText = $text.substr(0, $posLink)
        let $newText = $subText + '<a href="' + $urlLink + '">' + $labelLink + '</a>'
        return $newText
      }
      return $text
    }
  }
}
</script>

<style lang="scss">
    .privacy-flag{
        text-align: left;
        font-size:11px;
        td {
            vertical-align: center;
        }
        .privacy-flag-checkbox {
            width:20px;
        }
    }
    .privacy-flag-chk-big {
       font-size: 40px;
    }
    .privacy-flag.not-scrolled {
        color: silver;
    }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyFlag.vue